import setSliderSettings from './js/components/slider.js';

window.addEventListener( 'DOMContentLoaded', () => {

	const slider = document.querySelector( '.wombat-slider-container' );
	// inititalize slider
	if ( slider ) {

		setSliderSettings( slider );

	}

} );
